"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./BlockListItems.scss");
var _BlockListItemsMethods = require("./BlockListItemsMethods");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BlockListItems = _ref => {
  let {
    contentfulId,
    content,
    paddingClass,
    zIndex,
    type
  } = _ref;
  const centered = content?.centered;
  const wrapper = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: wrapper,
    className: `ter-block-list-items ${paddingClass ? paddingClass : ""} ${centered ? `ter-block-list-items--centered` : ""}`,
    style: {
      zIndex: zIndex + 1 || "auto"
    },
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, (0, _BlockListItemsMethods.renderBlockListItems)(content, type));
};
var _default = BlockListItems;
exports.default = _default;
BlockListItems.propTypes = {
  content: _propTypes.default.object,
  paddingClass: _propTypes.default.string,
  zIndex: _propTypes.default.number,
  type: _propTypes.default.string.isRequired,
  centered: _propTypes.default.bool
};